<template>
  <div>
    <h1><router-link to="/">MARC WILK</router-link></h1>
    <p> Adventure Enthusiast </p>
    <div class="icons">
      <a href="https://www.instagram.com/marc_wilk/" target="_blank" title="Instagram">
        <font-awesome-icon :icon="faInstagram" />
      </a>
      <a href="https://www.github.com/marcwilk/" target="_blank" title="Github">
        <font-awesome-icon :icon="faGithub" />
      </a>
      <a href="https://www.linkedin.com/in/marcwilk/" target="_blank" title="LinkedIn">
        <font-awesome-icon :icon="faLinkedin" />
      </a>
    </div>
  </div>
</template>

<script>
import { faLinkedin, faInstagram, faGithub } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  data() {
    return {
      faLinkedin,
      faInstagram,
      faGithub,
    };
  },
  components: {
    FontAwesomeIcon,
  },
};
</script>

<style lang="scss" scoped>
  .icons {
    display: block;
    width: 100%;
    text-align: right;
    margin-top: spacing(element);
    @include respond-to(medium) {
      margin-top: 0;
      margin-bottom: spacing(base);
      text-align: left;
    }
    a {
      color: color(white);
      margin: 0 0 0 spacing(base);
      font-size: mm(8);
      @include respond-to(medium) {
        margin: 0 spacing(base) 0 0;
        text-align: left;
      }
    }
  }
  a:visited {
    color: inherit;
  }
  a {
    color: color(white);
  }
  .mobile-title {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    flex: 1;
    justify-content: flex-end;
    h1 {
      width: 100%;
      text-align: right;
    }
    h1, p {
      padding-left: spacing(base);
      margin: 0;
    }
  }
</style>
